(() => {
  const campingOptionButton = '.camping-option-button';

  const init = () => {
    $('body')
      .on('click', campingOptionButton, showCampingOptionModal);
  }

  const showCampingOptionModal = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const selectedCampingOptionId = $element[0].dataset.campingOptionId;
    const campingOptions = $('#data-camping-option').data('camping-options');

    campingOptions.forEach(option => {
      if (option.id == selectedCampingOptionId) {
        $('.camping-option-detail-modal').empty();
        $('.camping-option-detail-modal').append(buildCampingOptionModal(option));
      }
    })
  }

  const buildCampingOptionModal = (option) => {
    const taxRate = $('#data-tax').data('tax-rate');
    const charge = option.charge * (1 + taxRate);
    var campingOption =
    `
      <div class="modal-body">
        <div class="title">${option.option_name}</div>
        <div class="price-block">
          <div class="block-left">
            <img src=${option.option_image.admin_show_thumb.url}>
          </div>
          <div class="block-right">
            <div class="price-block">
              <span class="price">${charge.toLocaleString()}</span>
              <span class="unit">円</span>
              <span class="tax">（税込）</span>
            </div>
            <div class="description modal-description">${option.description}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success inversion btn-block" data-dismiss="modal">閉じる</button>
      </div>
    `
    return campingOption;
  }
  $(init);
})();

